import { useTranslation } from 'react-i18next';
import { cn } from '@/shared/lib/cn';
import {
  resolveSubscriptionEventTone,
  subscriptionEventTypeLabelKey,
  SUBSCRIPTION_EVENT_TONE_STYLES,
} from '../utils/eventLabels';

interface SubscriptionEventTypeBadgeProps {
  eventType: string;
  className?: string;
}

export function SubscriptionEventTypeBadge({
  eventType,
  className,
}: SubscriptionEventTypeBadgeProps) {
  const { t } = useTranslation();
  const label = t(subscriptionEventTypeLabelKey(eventType), { defaultValue: eventType });
  const tone = resolveSubscriptionEventTone(eventType);

  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium whitespace-nowrap',
        SUBSCRIPTION_EVENT_TONE_STYLES[tone],
        className,
      )}
    >
      {label}
    </span>
  );
}
